module.exports = __webpack_public_path__ + "img/signup.adb209ba.jpg";